<template>
  <div class="pcard--task d-flex flex-wrap mb-2 item">
    <div v-if="unlink && !end" style="min-width: 30px;" class="pr-1 pl-1 pt-1">
      <i class="bx bx-trash text-danger" @click="unlinkEvent"></i>
    </div>

    <template v-if="!isItDefinition" @click="click">
      <div v-if="linkType" style="min-width: 70px;" @click="click" class="pr-1 pt-1">
        <task-relation-badge :type="linkType" :relatedTask="relatedTask" />
      </div>
      <div @click="click" class="pr-1 pt-1">
        <b>#{{ task.no }}</b>
      </div>

      <div @click="click" class="pr-1 pt-1">
        <task-status :status="task.status" :onlyDot="true" />
      </div>
      <div @click="click" class="pt-1">
        <task-priority :priority="task.priority" :onlyIcon="true" />
      </div>

      <div @click="click" class="pr-1">
        <task-avatar :account="task.assignee" class="mr-1" />
        <span v-if="showAssignee">{{ task.assignee.name }}</span>
      </div>
    </template>

    <div v-if="disableTooltip" @click="click" class="pr-1 pt-1">
      {{ task.name | translate }}
    </div>

    <div v-else @click="click" class="pr-1 pt-1" v-b-tooltip.hover :title="task.name | translate">
      {{ task.name | translate }}
    </div>
    <div v-if="unlink && end" style="min-width: 30px;" class="pr-1 pl-1 pt-1">
      <i class="bx bx-trash text-danger" @click="unlinkEvent"></i>
    </div>
    <div v-if="showDates">
      <div v-if="task.status == 'DONE' && task.donedate" style="min-width: 30px;" class="pr-1 pl-1 pt-1">{{ $t("task.donedate") }}:{{ task.donedate | date }}</div>
      <div v-if="task.status != 'DONE' && task.duedate" style="min-width: 30px;" class="pr-1 pl-1 pt-1">{{ $t("task.duedate") }}:{{ task.duedate | date }}</div>
    </div>
    <div class="ml-auto" v-if="isItDefinition">
      <i @click="editClicked(task)" class="mdi mdi-pencil text-warning hand"></i> <i @click="removeClicked(task)" class="mdi mdi-delete text-danger hand"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ["task", "showAssignee", "linkType", "unlink", "end", "isItDefinition", "relatedTask", "disableTooltip", "showDates"],

  data() {
    return {
      unLinkEvent: false,
    };
  },

  methods: {
    unlinkEvent() {
      this.$emit("unlinked", this.task);
    },
    click() {
      this.$emit("click", this.task);
    },
    editClicked(task) {
      this.$emit("editClicked", task);
    },
    removeClicked(task) {
      this.$emit("removeClicked", task);
    },
  },
};
</script>

<style scoped>
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item {
  border-radius: 7px;
  border: 1px solid rgb(231, 231, 231);
  padding: 5px;
}
</style>
